"use client";

import { c as _c } from "react/compiler-runtime";
import Drop, { DropInteractionParams, DropLocation } from "@/components/waves/drops/Drop";
import { ApiDrop } from "@/generated/models/ApiDrop";
import { getTimeAgoShort } from "@/helpers/Helpers";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import { getWaveRoute } from "@/helpers/navigation.helpers";
import { DropSize, ExtendedDrop } from "@/helpers/waves/drop.helpers";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { ActiveDropState } from "@/types/dropInteractionTypes";
import { INotificationPriorityAlert } from "@/types/feed.types";
import Link from "next/link";
import { useRouter } from "next/navigation";
export default function NotificationPriorityAlert(t0) {
  const $ = _c(41);
  const {
    notification,
    activeDrop,
    onReply,
    onQuote,
    onDropContentClick
  } = t0;
  const router = useRouter();
  const {
    isApp
  } = useDeviceInfo();
  let t1;
  if ($[0] !== notification.related_identity.pfp) {
    t1 = <div className="tw-h-7 tw-w-7">{notification.related_identity.pfp ? <img src={getScaledImageUri(notification.related_identity.pfp, ImageScale.W_AUTO_H_50)} alt="#" className="tw-flex-shrink-0 tw-object-contain tw-h-full tw-w-full tw-rounded-md tw-bg-iron-800 tw-ring-1 tw-ring-iron-700" /> : <div className="tw-flex-shrink-0 tw-object-contain tw-h-full tw-w-full tw-rounded-md tw-bg-iron-800 tw-ring-1 tw-ring-iron-700" />}</div>;
    $[0] = notification.related_identity.pfp;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `/${notification.related_identity.handle}`;
  let t3;
  if ($[2] !== notification.related_identity.handle || $[3] !== t2) {
    t3 = <Link href={t2} className="tw-no-underline tw-font-semibold">{notification.related_identity.handle}</Link>;
    $[2] = notification.related_identity.handle;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="tw-text-iron-400">sent a priority alert 🚨</span>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="tw-font-bold tw-mr-1 tw-text-xs tw-text-iron-400">•</span>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== notification.created_at) {
    t6 = getTimeAgoShort(notification.created_at);
    $[7] = notification.created_at;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t6) {
    t7 = <span className="tw-text-sm tw-text-iron-300 tw-font-normal tw-whitespace-nowrap">{t5}{" "}{t6}</span>;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t3 || $[12] !== t7) {
    t8 = <span className="tw-text-sm tw-font-normal tw-text-iron-50">{t3}{" "}{t4}{" "}{t7}</span>;
    $[11] = t3;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t1 || $[15] !== t8) {
    t9 = <div className="tw-flex tw-gap-x-2 tw-items-center">{t1}{t8}</div>;
    $[14] = t1;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const headerSection = t9;
  if (!notification.related_drops || notification.related_drops.length === 0) {
    let t10;
    if ($[17] !== headerSection) {
      t10 = <div className="tw-w-full tw-flex tw-gap-x-3"><div className="tw-w-full tw-flex tw-flex-col tw-space-y-2">{headerSection}</div></div>;
      $[17] = headerSection;
      $[18] = t10;
    } else {
      t10 = $[18];
    }
    return t10;
  }
  const baseWave = notification.related_drops[0]?.wave as any;
  const isDirectMessage = baseWave?.chat?.scope?.group?.is_direct_message ?? false;
  let t10;
  if ($[19] !== isApp || $[20] !== isDirectMessage || $[21] !== notification.related_drops[0] || $[22] !== router) {
    t10 = serialNo => {
      const firstDrop = notification.related_drops[0];
      if (!firstDrop?.wave?.id) {
        return;
      }
      router.push(getWaveRoute({
        waveId: firstDrop.wave.id,
        serialNo,
        isDirectMessage,
        isApp
      }));
    };
    $[19] = isApp;
    $[20] = isDirectMessage;
    $[21] = notification.related_drops[0];
    $[22] = router;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const onReplyClick = t10;
  let t11;
  if ($[24] !== isApp || $[25] !== isDirectMessage || $[26] !== router) {
    t11 = quote => {
      const quoteWave = quote.wave as any;
      const quoteIsDm = quoteWave?.chat?.scope?.group?.is_direct_message ?? isDirectMessage;
      router.push(getWaveRoute({
        waveId: quote.wave.id,
        serialNo: quote.serial_no,
        isDirectMessage: quoteIsDm,
        isApp
      }));
    };
    $[24] = isApp;
    $[25] = isDirectMessage;
    $[26] = router;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  const onQuoteClick = t11;
  let t12;
  if ($[28] !== notification.related_drops[0]) {
    t12 = {
      type: DropSize.FULL,
      ...notification.related_drops[0],
      stableKey: "",
      stableHash: ""
    };
    $[28] = notification.related_drops[0];
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== activeDrop || $[31] !== onDropContentClick || $[32] !== onQuote || $[33] !== onQuoteClick || $[34] !== onReply || $[35] !== onReplyClick || $[36] !== t12) {
    t13 = <Drop drop={t12} previousDrop={null} nextDrop={null} showWaveInfo={true} showReplyAndQuote={true} activeDrop={activeDrop} location={DropLocation.MY_STREAM} dropViewDropId={null} onReply={onReply} onQuote={onQuote} onReplyClick={onReplyClick} onQuoteClick={onQuoteClick} onDropContentClick={onDropContentClick} />;
    $[30] = activeDrop;
    $[31] = onDropContentClick;
    $[32] = onQuote;
    $[33] = onQuoteClick;
    $[34] = onReply;
    $[35] = onReplyClick;
    $[36] = t12;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== headerSection || $[39] !== t13) {
    t14 = <div className="tw-w-full tw-flex tw-gap-x-3"><div className="tw-w-full tw-flex tw-flex-col tw-space-y-2">{headerSection}{t13}</div></div>;
    $[38] = headerSection;
    $[39] = t13;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  return t14;
}